/*
 * Code generated by Speakeasy (https://speakeasy.com). DO NOT EDIT.
 */

import * as z from "zod";
import { ClosedEnum } from "../../types/enums.js";

/**
 * |Token | Service name|
 *
 * @remarks
 * |:---|:---|
 * | usps_priority | Priority Mail|
 * | usps_priority_express | Priority Mail Express|
 * | usps_media_mail | Media Mail, only for existing Shippo customers with grandfathered Media Mail option.|
 * | usps_priority_mail_international | Priority Mail International|
 * | usps_priority_mail_express_international | Priority Mail Express International|
 * | usps_first_class_package_international_service | First Class Package International|
 * | usps_ground_advantage | Ground Advantage |
 */
export const ServiceLevelUSPSEnum = {
  UspsPriority: "usps_priority",
  UspsPriorityExpress: "usps_priority_express",
  UspsMediaMail: "usps_media_mail",
  UspsPriorityMailInternational: "usps_priority_mail_international",
  UspsPriorityMailExpressInternational:
    "usps_priority_mail_express_international",
  UspsFirstClassPackageInternationalService:
    "usps_first_class_package_international_service",
  UspsGroundAdvantage: "usps_ground_advantage",
} as const;
/**
 * |Token | Service name|
 *
 * @remarks
 * |:---|:---|
 * | usps_priority | Priority Mail|
 * | usps_priority_express | Priority Mail Express|
 * | usps_media_mail | Media Mail, only for existing Shippo customers with grandfathered Media Mail option.|
 * | usps_priority_mail_international | Priority Mail International|
 * | usps_priority_mail_express_international | Priority Mail Express International|
 * | usps_first_class_package_international_service | First Class Package International|
 * | usps_ground_advantage | Ground Advantage |
 */
export type ServiceLevelUSPSEnum = ClosedEnum<typeof ServiceLevelUSPSEnum>;

/** @internal */
export const ServiceLevelUSPSEnum$inboundSchema: z.ZodNativeEnum<
  typeof ServiceLevelUSPSEnum
> = z.nativeEnum(ServiceLevelUSPSEnum);

/** @internal */
export const ServiceLevelUSPSEnum$outboundSchema: z.ZodNativeEnum<
  typeof ServiceLevelUSPSEnum
> = ServiceLevelUSPSEnum$inboundSchema;

/**
 * @internal
 * @deprecated This namespace will be removed in future versions. Use schemas and types that are exported directly from this module.
 */
export namespace ServiceLevelUSPSEnum$ {
  /** @deprecated use `ServiceLevelUSPSEnum$inboundSchema` instead. */
  export const inboundSchema = ServiceLevelUSPSEnum$inboundSchema;
  /** @deprecated use `ServiceLevelUSPSEnum$outboundSchema` instead. */
  export const outboundSchema = ServiceLevelUSPSEnum$outboundSchema;
}
